const translations = {
  fr: {
    lang: 'fr',
    dir: 'ltr',
    nav: {
      home: 'Accueil',
      kits: 'Nos Kits prêts à l\'emploi',
      contact: 'Contact',
      blog: 'Blog',
      cta: 'Devis gratuit',
      cart: 'Panier',
      gallery: 'Galerie',
    },
    gallery: {
      loadMore: 'Voir plus',
      produit: 'Bracelets & matériel',
      viewPhotos: 'Voir les photos',
      title: 'Galerie',
      subtitle: 'Photos et vidéos de soirées illuminées par Party LED',
      photos: 'Photos',
      videos: 'Vidéos',
      all: 'Tous les événements',
      mariage: 'Mariage',
      festival: 'Festival',
      concert: 'Concert', sport: 'Salle de sport',
      corporate: 'Entreprise',
      club: 'Club',
      autre: 'Autre',
      empty: 'Aucun média dans cette catégorie pour le moment.',
      watch: 'Regarder',
      close: 'Fermer',
      seo: 'Galerie photos et vidéos — bracelets LED pour mariages, festivals, soirées d\'entreprise et clubs.',
    },
    share: {
      label: 'Partager',
      copy: 'Copier le lien',
      copied: 'Lien copié !',
    },
    seo: {
      homeTitle: 'Party LED — Bracelet NFC & bracelet lumineux LED avec marquage | France & Monde',
      homeDesc: "Bracelets lumineux LED synchronisés (radio-commandés) avec marquage et puce NFC offerts : mariages, festivals, soirées d'entreprise, clubs. Kits de 50 à 1 000+ invités, prêts à l'emploi. Livraison dans le monde entier.",
    },
    discount: {
      badge: 'Offre de bienvenue',
      title: '10% de réduction',
      subtitle: 'sur votre première commande',
      desc: 'Inscrivez-vous et soyez le premier informé de nos nouveautés.',
      placeholder: 'Votre adresse email',
      cta: 'Obtenir mon code',
      thanks: 'Merci ! Votre code de réduction 10% :',
    },
    whatsapp: {
      open: 'Demander un devis sur WhatsApp',
      title: 'Devis en 1 clic',
      subtitle: 'Choisissez le bureau le plus proche de vous',
      europe: 'Europe — France',
      europeDesc: 'Nouvelle Vision, Marseille',
      uae: 'Moyen-Orient — UAE',
      uaeDesc: 'World Promotional Products, Dubai',
      recommended: 'Recommandé',
      message: 'Bonjour, je souhaite un devis pour un kit Party LED. Voici mon événement :',
    },
    hero: {
      badge: 'Animation immersive pour événements',
      title1: 'Transformez votre événement en une',
      titleHighlight: 'expérience inoubliable',
      cta: 'Découvrez nos kits prêts à l\'emploi',
    },
    kits: {
      title: 'Nos Kits prêts à l\'emploi',
      viewAll: 'Voir le catalogue complet',
      persons: 'Personnes',
      addToCart: 'Ajouter au panier',
    },
    howItWorks: {
      badge: 'Simple et efficace',
      title: 'Comment ça marche',
      step1Title: 'Équipez vos invités',
      step1Desc: 'Distribuez les bracelets LED à chaque participant. Un geste simple pour une transformation spectaculaire de votre événement.',
      step2Title: 'Retirez la languette',
      step2Desc: 'Il suffit de retirer la languette de protection de la pile : le bracelet s\'allume et se synchronise seul avec tous les autres. Aucun appairage, aucun réglage.',
      step3Title: 'Activez l\'expérience NFC',
      step3Desc: 'La puce NFC intégrée déverrouille une dimension digitale : contenus exclusifs, interactions personnalisées et souvenirs connectés.',
    },
    features: {
      badge: 'Deux technologies, une expérience',
      title: 'Technologie de pointe',
      ledTitle: 'LED Synchronisée',
      ledDesc: 'Créez un spectacle visuel collectif qui transforme chaque moment fort en souvenir inoubliable.',
      ledItems: [
        'Effets lumineux synchronisés sur tout le public',
        'Vagues de couleur pilotées en temps réel',
        'Ambiance immersive sur les moments clés',
        'Impact visuel spectaculaire à grande échelle',
      ],
      nfcTitle: 'NFC Interactive',
      nfcDesc: 'Ajoutez une dimension digitale et interactive qui engage vos invités bien au-delà de la lumière.',
      nfcItems: [
        'Accès à du contenu digital exclusif',
        'Interactions personnalisées pendant l\'événement',
        'Activations de marque et surprises connectées',
        'Engagement renforcé et souvenirs partageables',
      ],
    },
    useCases: {
      badge: 'Pour chaque occasion',
      title: 'Pensé pour vos événements / activités',
      items: [
        { title: 'Mariages', desc: 'Créez un moment lumineux synchronisé unique pour votre première danse ou votre entrée.' },
        { title: 'Soirées privées', desc: 'Transformez votre soirée en un spectacle immersif où chaque invité devient acteur.' },
        { title: 'Anniversaires', desc: 'Offrez un effet wow inoubliable pour les moments forts de la célébration.' },
        { title: 'Festivals', desc: 'Synchronisez des centaines de bracelets pour une expérience collective à grande échelle.' },
        { title: 'BDE / Étudiants', desc: 'Démarquez vos soirées étudiantes avec une animation LED innovante et mémorable.' },
        { title: 'Entreprise', desc: 'Renforcez la cohésion et l\'impact de vos séminaires, galas et team buildings.' },
        { title: 'Lancements', desc: 'Marquez les esprits lors de vos lancements de produits avec un show lumineux.' },
        { title: 'Activations de marque', desc: 'Créez des expériences interactives qui renforcent l\'engagement et la visibilité.' },
        { title: 'Concerts', desc: 'Étendez le show jusqu\'au dernier rang : la salle change de couleur sur chaque refrain.' },
        { title: 'Salles de sport', desc: 'Faites vibrer les tribunes aux couleurs du club, à l\'entrée des joueurs comme à chaque but.' },
      ],
    },
    immersion: {
      title: 'L\'émotion à l\'état pur',
      desc: 'Des centaines de bracelets qui pulsent au même rythme. Un spectacle collectif qui crée un moment d\'unité et d\'émotion partagée.',
    },
    benefits: {
      badge: 'Pourquoi nous choisir',
      title: 'Bien plus qu\'un simple accessoire',
      desc: 'Party LED est une solution événementielle complète qui transforme chaque rassemblement en une expérience immersive, interactive et mémorable.',
      items: [
        { title: 'Impact visuel spectaculaire', desc: 'Un show lumineux collectif qui marque les esprits et crée un effet wow instantané.' },
        { title: 'Déploiement simple et rapide', desc: 'Aucune compétence technique requise. Distribuez, connectez, lancez.' },
        { title: 'Expérience premium et innovante', desc: 'Positionnez votre événement comme une référence d\'innovation et de modernité.' },
        { title: 'Solution fiable et adaptable', desc: 'De 50 à 1000+ personnes, notre technologie s\'adapte à toutes les échelles.' },
      ],
    },
    trust: {
      badge: 'Ils nous font confiance',
      title: 'Conçu pour les professionnels',
      stats: [
        { value: '500+', label: 'Événements animés' },
        { value: '50K+', label: 'Bracelets distribués' },
        { value: '99%', label: 'Taux de satisfaction' },
        { value: '24/7', label: 'Support disponible' },
      ],
      reassurance: [
        { title: 'Installation simple', desc: 'Prêt à l\'emploi en quelques minutes, sans compétence technique.' },
        { title: 'Accompagnement dédié', desc: 'Notre équipe vous guide de la conception à la réalisation de votre événement.' },
        { title: 'Devis sur mesure', desc: 'Une solution adaptée à votre budget et au nombre de participants.' },
      ],
    },
    faq: {
      badge: 'Questions fréquentes',
      title: 'FAQ',
      items: [
        { q: 'Comment fonctionnent les bracelets LED ?', a: 'Chaque bracelet contient une puce radio. Il suffit de retirer la languette de protection de la pile : le bracelet s\'allume et se synchronise tout seul avec tous les autres, sans appairage. Le contrôleur inclus dans le kit permet ensuite de changer les couleurs et les effets en temps réel pour toute la salle.' },
        { q: 'Comment la console synchronise-t-elle les bracelets ?', a: 'La console émet un signal radio qui atteint simultanément tous les bracelets dans un rayon de plusieurs centaines de mètres. Vous pouvez programmer des séquences, changer les couleurs, créer des vagues lumineuses et déclencher des effets spéciaux en un clic.' },
        { q: 'À quoi sert la puce NFC ?', a: 'La puce NFC permet d\'ajouter une dimension interactive à chaque bracelet. En approchant un smartphone, vos invités peuvent accéder à du contenu exclusif, participer à des activations de marque, découvrir des surprises ou partager leur expérience sur les réseaux sociaux.' },
        { q: 'Pour quels types d\'événements cette solution est-elle adaptée ?', a: 'Notre solution s\'adapte à tous les formats : mariages, anniversaires, soirées privées, festivals, événements d\'entreprise, séminaires, galas, BDE, lancements de produits et activations de marque. De 50 à plus de 1000 personnes.' },
        { q: 'L\'installation est-elle compliquée ?', a: 'Pas du tout. Nos kits sont conçus pour être prêts à l\'emploi. Il suffit de distribuer les bracelets aux invités et de connecter la console. L\'ensemble est opérationnel en quelques minutes, sans aucune compétence technique requise.' },
        { q: 'Peut-on personnaliser l\'expérience ?', a: 'Absolument. Vous pouvez personnaliser les couleurs, les séquences, les effets et le rythme. La console offre un contrôle total pour adapter l\'animation au style de votre événement et à vos moments clés.' },
        { q: 'Comment commander ou demander un devis ?', a: 'Vous pouvez commander directement depuis notre catalogue ou nous contacter via la page Contact. Notre équipe vous répondra sous 24h avec une proposition adaptée à vos besoins.' },
      ],
    },
    finalCta: {
      title1: 'Prêt à créer un moment',
      titleHighlight: 'inoubliable',
      titleEnd: '?',
      desc: 'Offrez à vos invités bien plus qu\'un événement. Ajoutez lumière, émotion et interaction à votre prochaine occasion.',
      cta: 'Découvrir l\'expérience',
    },
    footer: {
      desc: 'Solution d\'animation immersive pour événements. Bracelets LED synchronisés et connectés par technologie NFC.',
      nav: 'Navigation',
      info: 'Informations',
      newsletter: 'Newsletter',
      newsletterDesc: 'Recevez nos actualités et offres exclusives.',
      emailPlaceholder: 'Votre email',
      legal: 'Mentions légales',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions générales',
      refund: 'Politique de remboursement',
      rights: 'Tous droits réservés.',
    },
    catalogue: {
      title: 'Nos Kits prêts à l\'emploi',
      subtitle: 'Kits Party LED de 50 à 1 000 personnes. Bracelets LED synchronisés, contrôleur au choix, marquage 1 couleur et lien NFC offerts.',
      filterAll: 'Tous',
      sortLabel: 'Trier par',
      sortDefault: 'Ordre par défaut',
      sortPriceLow: 'Prix croissant',
      sortPriceHigh: 'Prix décroissant',
      sortName: 'Nom',
    },
    contact: {
      title: 'Demande de Devis',
      subtitle: 'Décrivez votre événement et recevez un devis personnalisé pour votre kit LED',
      info: 'Informations de contact',
      europe: 'Nouvelle Vision (Europe)',
      uae: 'World Promotional Products (UAE)',
      email: 'Email',
      phone: 'Téléphone',
      formTitle: 'Décrivez votre événement',
      name: 'Nom complet',
      emailField: 'Email',
      phoneField: 'Téléphone',
      company: 'Société / Organisation',
      eventType: 'Type d\'événement',
      guestCount: 'Nombre d\'invités',
      eventDate: 'Date de l\'événement',
      message: 'Détails de votre événement',
      submit: 'Demander un devis gratuit',
      sending: 'Envoi en cours...',
      successTitle: 'Demande envoyée !',
      successMsg: 'Merci pour votre demande de devis. Notre équipe vous répondra sous 24 heures.',
      newQuote: 'Nouvelle demande',
      whyTitle: 'Pourquoi nous choisir ?',
      why1: 'Kits LED pour événements de 50 à 1000+ personnes',
      why2: 'Livraison rapide en France et aux Émirats',
      why3: 'Devis personnalisé sous 24h',
      why4: 'Support technique avant et pendant l\'événement',
      wedding: 'Mariage',
      festival: 'Festival',
      concert: 'Concert',
      privateParty: 'Soirée privée',
      corporate: 'Événement corporate',
      other: 'Autre',
      choose: 'Choisir...',
      messagePlaceholder: 'Décrivez votre événement, vos besoins spécifiques, la couleur souhaitée...',
    },
    blog: {
      title: 'Blog Party LED',
      subtitle: 'Conseils, guides et inspirations pour illuminer vos événements',
      all: 'Tous',
      readMore: 'Lire l\'article',
      noArticles: 'Aucun article pour le moment',
      loading: 'Chargement des articles...',
      backToBlog: 'Retour au blog',
      notFound: 'Article introuvable',
      share: 'Partager cet article',
      cta: 'Demander un devis gratuit',
      related: 'Articles similaires',
      newsletter: 'Restez informé',
      newsletterDesc: 'Recevez nos conseils, offres exclusives et nouveautés LED directement dans votre boîte mail.',
      subscribe: 'S\'inscrire',
      subscribed: 'Inscrit !',
    },
    cart: {
      title: 'Votre Panier',
      empty: 'Votre panier est vide',
      emptyDesc: 'Découvrez nos kits LED et ajoutez-les à votre panier',
      browseCatalogue: 'Parcourir le catalogue',
      remove: 'Supprimer',
      clearAll: 'Vider le panier',
      summary: 'Récapitulatif',
      subtotal: 'Sous-total',
      shipping: 'Livraison',
      free: 'Gratuite',
      total: 'Total',
      checkout: 'Passer la commande',
    },
    checkout: {
      title: 'Finaliser la commande',
      deliveryInfo: 'Informations de livraison',
      name: 'Nom complet',
      email: 'Email',
      phone: 'Téléphone',
      address: 'Adresse de livraison',
      paymentMethod: 'Méthode de paiement',
      stripe: 'Carte bancaire (Stripe)',
      stripeDesc: 'Paiement sécurisé par carte',
      paypal: 'PayPal',
      paypalDesc: 'Paiement via compte PayPal',
      pay: 'Payer',
      redirecting: 'Redirection...',
      summary: 'Récapitulatif',
      quantity: 'Quantité',
      subtotal: 'Sous-total',
      shipping: 'Livraison',
      free: 'Gratuite',
      total: 'Total',
      secure: 'Paiement 100% sécurisé avec Stripe ou PayPal',
      emptyCart: 'Panier vide',
      emptyCartDesc: 'Ajoutez des produits pour passer commande',
      viewCatalogue: 'Voir le catalogue',
    },
    product: {
      addToCart: 'Ajouter au panier',
      added: 'Ajouté au panier !',
      features: 'Caractéristiques',
      persons: 'Personnes',
      loading: 'Chargement...',
      back: 'Retour',
      inStock: 'En stock',
      unitsAvailable: 'unités disponibles',
      minOrder: 'Commande minimum',
      units: 'unités',
      unit: 'unité',
      quantity: 'Quantité',
      total: 'Total',
      braceletFeature: '{n} bracelets LED ultra-premium',
      controllerFeature: '1 contrôleur au choix : mini contrôleur / contrôleur pour application mobile / contrôleur professionnel pour ordinateur',
      brandingFeature: 'Offert : marquage 1 couleur sur le haut du bracelet',
      nfcFeature: 'Offert : la puce NFC avec programmation vers le lien de votre choix',
      optionFeature: 'Option : Animateur ou DJ + 1 technicien éclairage ou technicien d\'éclairage seul',
      controllerTitle: 'Contrôleur inclus — à votre choix',
      controllerMini: 'Mini Contrôleur',
      controllerMiniDesc: 'Compact et simple d\'utilisation. Idéal pour les petits événements.',
      controllerMobile: 'Contrôleur Application Mobile',
      controllerMobileDesc: 'Pilotez vos bracelets depuis votre smartphone via l\'app dédiée.',
      controllerPro: 'Contrôleur Professionnel',
      controllerProDesc: 'Console avancée pour ordinateur. Contrôle total pour les pros.',
      pdfDownload: 'Télécharger la grille tarifaire PDF',
      lowStock: 'Stock limité',
      reviews: 'Avis clients',
      noReviews: 'Aucun avis pour le moment. Soyez le premier !',
      writeReview: 'Laisser un avis',
      reviewName: 'Votre nom',
      reviewEmail: 'Votre email',
      reviewRating: 'Note',
      reviewComment: 'Votre commentaire',
      reviewSubmit: 'Envoyer mon avis',
      reviewThanks: 'Merci pour votre avis !',
      avgRating: 'note moyenne',
    },
    order: {
      verifying: 'Vérification du paiement...',
      pleaseWait: 'Veuillez patienter',
      confirmed: 'Paiement confirmé !',
      thanks: 'Merci pour votre achat',
      registered: 'Commande enregistrée',
      expired: 'La session de paiement a expiré',
      orderRegistered: 'Votre commande a été enregistrée',
    },
  },

  en: {
    lang: 'en',
    dir: 'ltr',
    nav: {
      home: 'Home',
      kits: 'Our Ready-to-Use Kits',
      contact: 'Contact',
      blog: 'Blog',
      cta: 'Free quote',
      cart: 'Cart',
      gallery: 'Gallery',
    },
    gallery: {
      loadMore: 'Load more',
      produit: 'Wristbands & gear',
      concert: 'Concert', sport: 'Sports venue',
      viewPhotos: 'View photos',
      title: 'Gallery',
      subtitle: 'Photos and videos of parties lit up by Party LED',
      photos: 'Photos',
      videos: 'Videos',
      all: 'All events',
      mariage: 'Wedding',
      festival: 'Festival',
      corporate: 'Corporate',
      club: 'Club',
      autre: 'Other',
      empty: 'No media in this category yet.',
      watch: 'Watch',
      close: 'Close',
      seo: 'Photo and video gallery — LED wristbands for weddings, festivals, corporate events and clubs.',
    },
    share: {
      label: 'Share',
      copy: 'Copy link',
      copied: 'Link copied!',
    },
    seo: {
      homeTitle: 'Party LED — NFC & light-up LED wristbands with custom branding | Worldwide',
      homeDesc: 'Radio-controlled synchronised light-up LED wristbands with free custom branding and NFC chip: weddings, festivals, corporate parties and clubs. Kits from 50 to 1,000+ guests, ready to use. Worldwide delivery.',
    },
    discount: {
      badge: 'Welcome offer',
      title: '10% off',
      subtitle: 'on your first order',
      desc: 'Subscribe and be the first to hear about our news.',
      placeholder: 'Your email address',
      cta: 'Get my code',
      thanks: 'Thank you! Your 10% discount code:',
    },
    whatsapp: {
      open: 'Request a quote on WhatsApp',
      title: 'Quote in 1 click',
      subtitle: 'Pick the office closest to you',
      europe: 'Europe — France',
      europeDesc: 'Nouvelle Vision, Marseille',
      uae: 'Middle East — UAE',
      uaeDesc: 'World Promotional Products, Dubai',
      recommended: 'Recommended',
      message: 'Hello, I would like a quote for a Party LED kit. Here is my event:',
    },
    hero: {
      badge: 'Immersive event entertainment',
      title1: 'Turn your event into an',
      titleHighlight: 'unforgettable experience',
      cta: 'Discover our ready-to-use kits',
    },
    kits: {
      title: 'Our Ready-to-Use Kits',
      viewAll: 'View full catalogue',
      persons: 'Guests',
      addToCart: 'Add to cart',
    },
    howItWorks: {
      badge: 'Simple and effective',
      title: 'How it works',
      step1Title: 'Equip your guests',
      step1Desc: 'Distribute LED wristbands to each guest. One simple gesture for a spectacular transformation of your event.',
      step2Title: 'Pull the battery tab',
      step2Desc: 'Simply pull out the battery protection tab: the wristband switches on and syncs by itself with all the others. No pairing, no setup.',
      step3Title: 'Activate the NFC experience',
      step3Desc: 'The built-in NFC chip unlocks a digital dimension: exclusive content, personalized interactions and connected memories.',
    },
    features: {
      badge: 'Two technologies, one experience',
      title: 'Cutting-edge technology',
      ledTitle: 'Synchronized LED',
      ledDesc: 'Create a collective visual spectacle that turns every key moment into an unforgettable memory.',
      ledItems: [
        'Synchronized light effects across the entire audience',
        'Real-time controlled color waves',
        'Immersive atmosphere for key moments',
        'Spectacular visual impact at scale',
      ],
      nfcTitle: 'Interactive NFC',
      nfcDesc: 'Add a digital and interactive dimension that engages your guests far beyond light.',
      nfcItems: [
        'Access to exclusive digital content',
        'Personalized interactions during the event',
        'Brand activations and connected surprises',
        'Enhanced engagement and shareable memories',
      ],
    },
    useCases: {
      badge: 'For every occasion',
      title: 'Designed for your events / activities',
      items: [
        { title: 'Weddings', desc: 'Create a unique synchronized light moment for your first dance or grand entrance.' },
        { title: 'Private parties', desc: 'Transform your party into an immersive show where every guest becomes part of the spectacle.' },
        { title: 'Birthdays', desc: 'Deliver an unforgettable wow effect for the celebration\'s highlight moments.' },
        { title: 'Festivals', desc: 'Synchronize hundreds of wristbands for a large-scale collective experience.' },
        { title: 'Student events', desc: 'Make your student parties stand out with innovative and memorable LED entertainment.' },
        { title: 'Corporate', desc: 'Enhance cohesion and impact at your seminars, galas and team buildings.' },
        { title: 'Product launches', desc: 'Make a lasting impression at your product launches with a stunning light show.' },
        { title: 'Brand activations', desc: 'Create interactive experiences that boost engagement and visibility.' },
        { title: 'Concerts', desc: 'Extend the show to the very last row: the room changes colour on every chorus.' },
        { title: 'Sports venues', desc: 'Light up the stands in club colours, for the player entrance and every goal.' },
      ],
    },
    immersion: {
      title: 'Pure emotion',
      desc: 'Hundreds of wristbands pulsing in unison. A collective spectacle creating a moment of unity and shared emotion.',
    },
    benefits: {
      badge: 'Why choose us',
      title: 'Much more than a simple accessory',
      desc: 'Party LED is a complete event solution that transforms every gathering into an immersive, interactive and memorable experience.',
      items: [
        { title: 'Spectacular visual impact', desc: 'A collective light show that captivates minds and creates an instant wow effect.' },
        { title: 'Quick and easy setup', desc: 'No technical skills required. Distribute, connect, launch.' },
        { title: 'Premium innovative experience', desc: 'Position your event as a benchmark of innovation and modernity.' },
        { title: 'Reliable and scalable', desc: 'From 50 to 1000+ guests, our technology adapts to any scale.' },
      ],
    },
    trust: {
      badge: 'They trust us',
      title: 'Built for professionals',
      stats: [
        { value: '500+', label: 'Events powered' },
        { value: '50K+', label: 'Wristbands distributed' },
        { value: '99%', label: 'Satisfaction rate' },
        { value: '24/7', label: 'Support available' },
      ],
      reassurance: [
        { title: 'Easy setup', desc: 'Ready to use in minutes, no technical skills needed.' },
        { title: 'Dedicated support', desc: 'Our team guides you from planning to execution.' },
        { title: 'Custom quotes', desc: 'A solution tailored to your budget and number of guests.' },
      ],
    },
    faq: {
      badge: 'Frequently asked questions',
      title: 'FAQ',
      items: [
        { q: 'How do the LED wristbands work?', a: 'Each wristband contains a radio chip. Simply pull out the battery protection tab: the wristband switches on and syncs by itself with all the others, with no pairing. The controller included in the kit then lets you change colours and effects in real time for the whole room.' },
        { q: 'How does the console synchronize the wristbands?', a: 'The console emits a radio signal that simultaneously reaches all wristbands within a range of several hundred meters. You can program sequences, change colors, create light waves and trigger special effects with one click.' },
        { q: 'What is the NFC chip for?', a: 'The NFC chip adds an interactive dimension to each wristband. By bringing a smartphone close, guests can access exclusive content, participate in brand activations, discover surprises or share their experience on social media.' },
        { q: 'What types of events is this solution suitable for?', a: 'Our solution adapts to all formats: weddings, birthdays, private parties, festivals, corporate events, seminars, galas, student events, product launches and brand activations. From 50 to over 1000 guests.' },
        { q: 'Is the setup complicated?', a: 'Not at all. Our kits are designed to be ready to use. Simply distribute the wristbands and connect the console. Everything is operational in minutes, with no technical skills required.' },
        { q: 'Can the experience be customized?', a: 'Absolutely. You can customize colors, sequences, effects and rhythm. The console offers full control to adapt the animation to your event style and key moments.' },
        { q: 'How to order or request a quote?', a: 'You can order directly from our catalogue or contact us via the Contact page. Our team will respond within 24h with a tailored proposal.' },
      ],
    },
    finalCta: {
      title1: 'Ready to create an',
      titleHighlight: 'unforgettable',
      titleEnd: ' moment?',
      desc: 'Give your guests much more than an event. Add light, emotion and interaction to your next occasion.',
      cta: 'Discover the experience',
    },
    footer: {
      desc: 'Immersive event entertainment solution. Synchronized LED wristbands connected via NFC technology.',
      nav: 'Navigation',
      info: 'Information',
      newsletter: 'Newsletter',
      newsletterDesc: 'Receive our news and exclusive offers.',
      emailPlaceholder: 'Your email',
      legal: 'Legal notice',
      privacy: 'Privacy policy',
      terms: 'Terms & conditions',
      refund: 'Refund policy',
      rights: 'All rights reserved.',
    },
    catalogue: {
      title: 'Our Ready-to-Use Kits',
      subtitle: 'Party LED kits from 50 to 1000 guests. Synchronized LED wristbands with central console and NFC.',
      filterAll: 'All',
      sortLabel: 'Sort by',
      sortDefault: 'Default order',
      sortPriceLow: 'Price: Low to High',
      sortPriceHigh: 'Price: High to Low',
      sortName: 'Name',
    },
    contact: {
      title: 'Request a Quote',
      subtitle: 'Describe your event and receive a customized quote for your LED kit',
      info: 'Contact Information',
      europe: 'Nouvelle Vision (Europe)',
      uae: 'World Promotional Products (UAE)',
      email: 'Email',
      phone: 'Phone',
      formTitle: 'Describe your event',
      name: 'Full name',
      emailField: 'Email',
      phoneField: 'Phone',
      company: 'Company / Organization',
      eventType: 'Event type',
      guestCount: 'Number of guests',
      eventDate: 'Event date',
      message: 'Event details',
      submit: 'Request a free quote',
      sending: 'Sending...',
      successTitle: 'Request sent!',
      successMsg: 'Thank you for your quote request. Our team will respond within 24 hours.',
      newQuote: 'New request',
      whyTitle: 'Why choose us?',
      why1: 'LED kits for events from 50 to 1000+ guests',
      why2: 'Fast delivery in France and UAE',
      why3: 'Custom quote within 24h',
      why4: 'Technical support before and during the event',
      wedding: 'Wedding', festival: 'Festival', concert: 'Concert',
      privateParty: 'Private party', corporate: 'Corporate event', other: 'Other',
      choose: 'Choose...',
      messagePlaceholder: 'Describe your event, specific needs, desired color...',
    },
    blog: {
      title: 'Party LED Blog',
      subtitle: 'Tips, guides and inspiration to light up your events',
      all: 'All',
      readMore: 'Read article',
      noArticles: 'No articles yet',
      loading: 'Loading articles...',
      backToBlog: 'Back to blog',
      notFound: 'Article not found',
      share: 'Share this article',
      cta: 'Request a free quote',
      related: 'Related articles',
      newsletter: 'Stay informed',
      newsletterDesc: 'Receive our tips, exclusive offers and LED news directly in your inbox.',
      subscribe: 'Subscribe',
      subscribed: 'Subscribed!',
    },
    cart: {
      title: 'Your Cart',
      empty: 'Your cart is empty',
      emptyDesc: 'Discover our LED kits and add them to your cart',
      browseCatalogue: 'Browse catalogue',
      remove: 'Remove',
      clearAll: 'Clear cart',
      summary: 'Summary',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      free: 'Free',
      total: 'Total',
      checkout: 'Proceed to checkout',
    },
    checkout: {
      title: 'Complete your order',
      deliveryInfo: 'Delivery information',
      name: 'Full name', email: 'Email', phone: 'Phone',
      address: 'Delivery address',
      paymentMethod: 'Payment method',
      stripe: 'Credit card (Stripe)', stripeDesc: 'Secure card payment',
      paypal: 'PayPal', paypalDesc: 'Pay via PayPal account',
      pay: 'Pay', redirecting: 'Redirecting...',
      summary: 'Summary', quantity: 'Quantity',
      subtotal: 'Subtotal', shipping: 'Shipping', free: 'Free', total: 'Total',
      secure: '100% secure payment with Stripe or PayPal',
      emptyCart: 'Empty cart', emptyCartDesc: 'Add products to place an order',
      viewCatalogue: 'View catalogue',
    },
    product: {
      addToCart: 'Add to cart', added: 'Added to cart!',
      features: 'Features', persons: 'Guests', loading: 'Loading...',
      back: 'Back',
      inStock: 'In stock',
      unitsAvailable: 'units available',
      minOrder: 'Minimum order',
      units: 'units',
      unit: 'unit',
      quantity: 'Quantity',
      total: 'Total',
      braceletFeature: '{n} ultra-premium LED wristbands',
      controllerFeature: '1 controller of your choice: mini controller / mobile app controller / professional computer controller',
      brandingFeature: 'Free: 1-colour branding on the top of the wristband',
      nfcFeature: 'Free: NFC chip programmed to the link of your choice',
      optionFeature: 'Option: Entertainer or DJ + 1 lighting technician or lighting technician alone',
      controllerTitle: 'Controller included — your choice',
      controllerMini: 'Mini Controller',
      controllerMiniDesc: 'Compact and easy to use. Ideal for small events.',
      controllerMobile: 'Mobile App Controller',
      controllerMobileDesc: 'Control your wristbands from your smartphone via the dedicated app.',
      controllerPro: 'Professional Controller',
      controllerProDesc: 'Advanced computer console. Full control for professionals.',
      pdfDownload: 'Download PDF price grid',
      lowStock: 'Low stock',
      reviews: 'Customer reviews',
      noReviews: 'No reviews yet. Be the first!',
      writeReview: 'Write a review',
      reviewName: 'Your name',
      reviewEmail: 'Your email',
      reviewRating: 'Rating',
      reviewComment: 'Your comment',
      reviewSubmit: 'Submit review',
      reviewThanks: 'Thank you for your review!',
      avgRating: 'average rating',
    },
    order: {
      verifying: 'Verifying payment...', pleaseWait: 'Please wait',
      confirmed: 'Payment confirmed!', thanks: 'Thank you for your purchase',
      registered: 'Order registered', expired: 'Payment session expired',
      orderRegistered: 'Your order has been registered',
    },
  },

  ar: {
    lang: 'ar',
    dir: 'rtl',
    nav: {
      home: 'الرئيسية',
      kits: 'أطقمنا الجاهزة',
      contact: 'اتصل بنا',
      blog: 'المدونة',
      cta: 'طلب عرض سعر',
      cart: 'السلة',
      gallery: 'معرض الصور',
    },
    gallery: {
      loadMore: 'عرض المزيد',
      produit: 'الأسورة والتجهيزات',
      concert: 'حفل موسيقي', sport: 'قاعة رياضية',
      viewPhotos: 'عرض الصور',
      title: 'المعرض',
      subtitle: 'صور وفيديوهات لحفلات أضاءتها Party LED',
      photos: 'الصور',
      videos: 'الفيديوهات',
      all: 'جميع المناسبات',
      mariage: 'حفل زفاف',
      festival: 'مهرجان',
      corporate: 'شركات',
      club: 'نادي',
      autre: 'أخرى',
      empty: 'لا توجد وسائط في هذه الفئة حالياً.',
      watch: 'مشاهدة',
      close: 'إغلاق',
      seo: 'معرض الصور والفيديو — أسورة LED لحفلات الزفاف والمهرجانات وفعاليات الشركات والنوادي.',
    },
    share: {
      label: 'مشاركة',
      copy: 'نسخ الرابط',
      copied: 'تم نسخ الرابط!',
    },
    seo: {
      homeTitle: 'Party LED — أسورة LED متزامنة للفعاليات | فرنسا ودبي',
      homeDesc: 'أسورة LED متزامنة لحفلات الزفاف والمهرجانات وفعاليات الشركات والنوادي. طباعة بلون واحد ورابط NFC مجانًا. أطقم من 50 إلى 1000 شخص. توصيل إلى فرنسا ودبي.',
    },
    discount: {
      badge: 'عرض الترحيب',
      title: 'خصم 10%',
      subtitle: 'على طلبك الأول',
      desc: 'اشترك وكن أول من يعرف أخبارنا الجديدة.',
      placeholder: 'عنوان بريدك الإلكتروني',
      cta: 'احصل على الرمز',
      thanks: 'شكرًا لك! رمز الخصم 10% الخاص بك:',
    },
    whatsapp: {
      open: 'اطلب عرض سعر على واتساب',
      title: 'عرض سعر بنقرة واحدة',
      subtitle: 'اختر المكتب الأقرب إليك',
      europe: 'أوروبا — فرنسا',
      europeDesc: 'Nouvelle Vision، مرسيليا',
      uae: 'الشرق الأوسط — الإمارات',
      uaeDesc: 'World Promotional Products، دبي',
      recommended: 'موصى به',
      message: 'مرحبًا، أرغب في الحصول على عرض سعر لطقم Party LED. تفاصيل مناسبتي:',
    },
    hero: {
      badge: 'ترفيه غامر للفعاليات',
      title1: 'حوّل فعاليتك إلى',
      titleHighlight: 'تجربة لا تُنسى',
      cta: 'اكتشف أطقمنا الجاهزة للاستخدام',
    },
    kits: {
      title: 'أطقمنا الجاهزة للاستخدام',
      viewAll: 'عرض الكتالوج الكامل',
      persons: 'ضيف',
      addToCart: 'أضف إلى السلة',
    },
    howItWorks: {
      badge: 'بسيط وفعّال',
      title: 'كيف يعمل',
      step1Title: 'جهّز ضيوفك',
      step1Desc: 'وزّع أساور LED على كل مشارك. خطوة بسيطة لتحويل فعاليتك بشكل مذهل.',
      step2Title: 'اسحب لسان البطارية',
      step2Desc: 'يكفي سحب لسان حماية البطارية: يضيء السوار ويتزامن تلقائيًا مع جميع الأسورة الأخرى. بدون إقران وبدون إعدادات.',
      step3Title: 'فعّل تجربة NFC',
      step3Desc: 'شريحة NFC المدمجة تفتح بُعداً رقمياً: محتوى حصري وتفاعلات مخصصة وذكريات متصلة.',
    },
    features: {
      badge: 'تقنيتان، تجربة واحدة',
      title: 'تقنية متطورة',
      ledTitle: 'LED متزامن',
      ledDesc: 'أنشئ عرضاً بصرياً جماعياً يحوّل كل لحظة مميزة إلى ذكرى لا تُنسى.',
      ledItems: [
        'تأثيرات ضوئية متزامنة على كل الجمهور',
        'موجات لونية يتم التحكم بها في الوقت الفعلي',
        'أجواء غامرة في اللحظات الرئيسية',
        'تأثير بصري مذهل على نطاق واسع',
      ],
      nfcTitle: 'NFC تفاعلي',
      nfcDesc: 'أضف بُعداً رقمياً وتفاعلياً يشرك ضيوفك بعيداً عن مجرد الضوء.',
      nfcItems: [
        'وصول إلى محتوى رقمي حصري',
        'تفاعلات مخصصة أثناء الفعالية',
        'تفعيل العلامة التجارية ومفاجآت متصلة',
        'تعزيز المشاركة وذكريات قابلة للمشاركة',
      ],
    },
    useCases: {
      badge: 'لكل مناسبة',
      title: 'مصمم لفعالياتكم وأنشطتكم',
      items: [
        { title: 'حفلات الزفاف', desc: 'أنشئ لحظة ضوئية متزامنة فريدة لرقصتك الأولى أو دخولك.' },
        { title: 'الحفلات الخاصة', desc: 'حوّل حفلتك إلى عرض غامر يصبح فيه كل ضيف جزءاً من المشهد.' },
        { title: 'أعياد الميلاد', desc: 'قدّم تأثير واو لا يُنسى للحظات المميزة في الاحتفال.' },
        { title: 'المهرجانات', desc: 'زامن مئات الأساور لتجربة جماعية على نطاق واسع.' },
        { title: 'فعاليات الطلاب', desc: 'ميّز حفلاتك الطلابية بترفيه LED مبتكر ولا يُنسى.' },
        { title: 'الشركات', desc: 'عزّز التماسك والتأثير في ندواتك وحفلاتك وأنشطة بناء الفريق.' },
        { title: 'إطلاق المنتجات', desc: 'اترك انطباعاً دائماً في إطلاق منتجاتك بعرض ضوئي مذهل.' },
        { title: 'تفعيل العلامات التجارية', desc: 'أنشئ تجارب تفاعلية تعزز المشاركة والظهور.' },
        { title: 'حفلات موسيقية', desc: 'امدد العرض حتى الصف الأخير: تتغير ألوان القاعة مع كل لازمة.' },
        { title: 'صالات رياضية', desc: 'أضئ المدرجات بألوان النادي عند دخول اللاعبين وفي كل هدف.' },
      ],
    },
    immersion: {
      title: 'المشاعر في أنقى صورها',
      desc: 'مئات الأساور تنبض بإيقاع واحد. عرض جماعي يخلق لحظة وحدة ومشاعر مشتركة.',
    },
    benefits: {
      badge: 'لماذا تختارنا',
      title: 'أكثر بكثير من مجرد إكسسوار',
      desc: 'Party LED هو حل فعاليات متكامل يحوّل كل تجمع إلى تجربة غامرة وتفاعلية ولا تُنسى.',
      items: [
        { title: 'تأثير بصري مذهل', desc: 'عرض ضوئي جماعي يأسر العقول ويخلق تأثير واو فوري.' },
        { title: 'إعداد سريع وسهل', desc: 'لا حاجة لمهارات تقنية. وزّع، اتصل، انطلق.' },
        { title: 'تجربة مبتكرة فاخرة', desc: 'ضع فعاليتك كمرجع للابتكار والحداثة.' },
        { title: 'موثوق وقابل للتوسع', desc: 'من 50 إلى أكثر من 1000 ضيف، تقنيتنا تتكيف مع أي حجم.' },
      ],
    },
    trust: {
      badge: 'يثقون بنا',
      title: 'مصمم للمحترفين',
      stats: [
        { value: '+500', label: 'فعالية' },
        { value: '+50K', label: 'سوار تم توزيعه' },
        { value: '99%', label: 'نسبة الرضا' },
        { value: '24/7', label: 'الدعم متاح' },
      ],
      reassurance: [
        { title: 'تركيب سهل', desc: 'جاهز للاستخدام في دقائق، بدون مهارات تقنية.' },
        { title: 'دعم مخصص', desc: 'فريقنا يرافقك من التخطيط إلى التنفيذ.' },
        { title: 'عروض أسعار مخصصة', desc: 'حل يناسب ميزانيتك وعدد ضيوفك.' },
      ],
    },
    faq: {
      badge: 'الأسئلة الشائعة',
      title: 'الأسئلة المتكررة',
      items: [
        { q: 'كيف تعمل أساور LED؟', a: 'يحتوي كل سوار على شريحة راديو. يكفي سحب لسان حماية البطارية: يضيء السوار ويتزامن تلقائيًا مع جميع الأسورة الأخرى بدون إقران. ثم تتيح وحدة التحكم المرفقة بالطقم تغيير الألوان والمؤثرات في الوقت الفعلي للقاعة بأكملها.' },
        { q: 'كيف تزامن وحدة التحكم الأساور؟', a: 'تبث وحدة التحكم إشارة راديو تصل في وقت واحد إلى جميع الأساور في نطاق عدة مئات من الأمتار. يمكنك برمجة التسلسلات وتغيير الألوان وإنشاء موجات ضوئية وتشغيل تأثيرات خاصة بنقرة واحدة.' },
        { q: 'ما فائدة شريحة NFC؟', a: 'تضيف شريحة NFC بعداً تفاعلياً لكل سوار. بتقريب الهاتف الذكي، يمكن للضيوف الوصول إلى محتوى حصري والمشاركة في تفعيلات العلامة التجارية واكتشاف المفاجآت أو مشاركة تجربتهم على وسائل التواصل الاجتماعي.' },
        { q: 'ما أنواع الفعاليات المناسبة لهذا الحل؟', a: 'حلنا يتكيف مع جميع الأشكال: حفلات الزفاف، أعياد الميلاد، الحفلات الخاصة، المهرجانات، فعاليات الشركات، الندوات، الحفلات، فعاليات الطلاب، إطلاق المنتجات وتفعيل العلامات التجارية. من 50 إلى أكثر من 1000 ضيف.' },
        { q: 'هل التركيب معقد؟', a: 'أبداً. أطقمنا مصممة لتكون جاهزة للاستخدام. فقط وزّع الأساور على الضيوف واتصل بوحدة التحكم. كل شيء جاهز في دقائق بدون أي مهارات تقنية.' },
        { q: 'هل يمكن تخصيص التجربة؟', a: 'بالتأكيد. يمكنك تخصيص الألوان والتسلسلات والتأثيرات والإيقاع. وحدة التحكم توفر تحكماً كاملاً لتكييف الرسوم المتحركة مع أسلوب فعاليتك ولحظاتك الرئيسية.' },
        { q: 'كيف أطلب أو أحصل على عرض سعر؟', a: 'يمكنك الطلب مباشرة من الكتالوج أو الاتصال بنا عبر صفحة الاتصال. سيرد فريقنا خلال 24 ساعة باقتراح مخصص.' },
      ],
    },
    finalCta: {
      title1: 'مستعد لخلق لحظة',
      titleHighlight: 'لا تُنسى',
      titleEnd: '؟',
      desc: 'امنح ضيوفك أكثر بكثير من مجرد فعالية. أضف الضوء والمشاعر والتفاعل إلى مناسبتك القادمة.',
      cta: 'اكتشف التجربة',
    },
    footer: {
      desc: 'حل ترفيه غامر للفعاليات. أساور LED متزامنة ومتصلة عبر تقنية NFC.',
      nav: 'التنقل',
      info: 'معلومات',
      newsletter: 'النشرة الإخبارية',
      newsletterDesc: 'احصل على أخبارنا وعروضنا الحصرية.',
      emailPlaceholder: 'بريدك الإلكتروني',
      legal: 'إشعار قانوني',
      privacy: 'سياسة الخصوصية',
      terms: 'الشروط والأحكام',
      refund: 'سياسة الاسترداد',
      rights: 'جميع الحقوق محفوظة.',
    },
    catalogue: {
      title: 'أطقمنا الجاهزة للاستخدام',
      subtitle: 'أطقم Party LED من 50 إلى 1000 ضيف. أساور LED متزامنة مع وحدة تحكم مركزية وNFC.',
      filterAll: 'الكل',
      sortLabel: 'ترتيب حسب',
      sortDefault: 'الترتيب الافتراضي',
      sortPriceLow: 'السعر: من الأقل للأعلى',
      sortPriceHigh: 'السعر: من الأعلى للأقل',
      sortName: 'الاسم',
    },
    contact: {
      title: 'طلب عرض سعر',
      subtitle: 'صف حدثك واحصل على عرض سعر مخصص لمجموعة LED الخاصة بك',
      info: 'معلومات الاتصال',
      europe: 'Nouvelle Vision (أوروبا)',
      uae: 'World Promotional Products (الإمارات)',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      formTitle: 'صف حدثك',
      name: 'الاسم الكامل',
      emailField: 'البريد الإلكتروني',
      phoneField: 'الهاتف',
      company: 'الشركة / المؤسسة',
      eventType: 'نوع الحدث',
      guestCount: 'عدد الضيوف',
      eventDate: 'تاريخ الحدث',
      message: 'تفاصيل الحدث',
      submit: 'طلب عرض سعر مجاني',
      sending: 'جاري الإرسال...',
      successTitle: 'تم إرسال الطلب!',
      successMsg: 'شكراً لطلبك. سيرد فريقنا خلال 24 ساعة.',
      newQuote: 'طلب جديد',
      whyTitle: 'لماذا تختارنا؟',
      why1: 'مجموعات LED لأحداث من 50 إلى 1000+ شخص',
      why2: 'توصيل سريع في فرنسا والإمارات',
      why3: 'عرض سعر مخصص خلال 24 ساعة',
      why4: 'دعم فني قبل وأثناء الحدث',
      wedding: 'زفاف', festival: 'مهرجان', concert: 'حفلة موسيقية',
      privateParty: 'حفلة خاصة', corporate: 'حدث مؤسسي', other: 'أخرى',
      choose: 'اختر...',
      messagePlaceholder: 'صف حدثك، احتياجاتك الخاصة، اللون المطلوب...',
    },
    blog: {
      title: 'مدونة Party LED',
      subtitle: 'نصائح وأدلة وإلهام لإضاءة أحداثك',
      all: 'الكل',
      readMore: 'اقرأ المقال',
      noArticles: 'لا توجد مقالات حالياً',
      loading: 'جاري تحميل المقالات...',
      backToBlog: 'العودة للمدونة',
      notFound: 'المقال غير موجود',
      share: 'شارك هذا المقال',
      cta: 'اطلب عرض سعر مجاني',
      related: 'مقالات مشابهة',
      newsletter: 'ابقَ على اطلاع',
      newsletterDesc: 'احصل على نصائحنا وعروضنا الحصرية مباشرة في بريدك.',
      subscribe: 'اشترك',
      subscribed: 'تم الاشتراك!',
    },
    cart: {
      title: 'سلة التسوق',
      empty: 'سلة التسوق فارغة',
      emptyDesc: 'اكتشف مجموعات LED وأضفها إلى سلتك',
      browseCatalogue: 'تصفح الكتالوج',
      remove: 'إزالة',
      clearAll: 'تفريغ السلة',
      summary: 'الملخص',
      subtotal: 'المجموع الفرعي',
      shipping: 'الشحن',
      free: 'مجاني',
      total: 'المجموع',
      checkout: 'إتمام الطلب',
    },
    checkout: {
      title: 'إتمام الطلب',
      deliveryInfo: 'معلومات التوصيل',
      name: 'الاسم الكامل', email: 'البريد الإلكتروني', phone: 'الهاتف',
      address: 'عنوان التوصيل',
      paymentMethod: 'طريقة الدفع',
      stripe: 'بطاقة ائتمان (Stripe)', stripeDesc: 'دفع آمن بالبطاقة',
      paypal: 'PayPal', paypalDesc: 'الدفع عبر حساب PayPal',
      pay: 'ادفع', redirecting: 'جاري التحويل...',
      summary: 'الملخص', quantity: 'الكمية',
      subtotal: 'المجموع الفرعي', shipping: 'الشحن', free: 'مجاني', total: 'المجموع',
      secure: 'دفع آمن 100% مع Stripe أو PayPal',
      emptyCart: 'السلة فارغة', emptyCartDesc: 'أضف منتجات لإتمام الطلب',
      viewCatalogue: 'عرض الكتالوج',
    },
    product: {
      addToCart: 'أضف إلى السلة', added: 'تمت الإضافة!',
      features: 'المميزات', persons: 'أشخاص', loading: 'جاري التحميل...',
      back: 'رجوع',
      inStock: 'متوفر',
      unitsAvailable: 'وحدة متاحة',
      minOrder: 'الحد الأدنى للطلب',
      units: 'وحدة',
      unit: 'وحدة',
      quantity: 'الكمية',
      total: 'المجموع',
      braceletFeature: '{n} أسورة LED فائقة الجودة',
      controllerFeature: '1 وحدة تحكم حسب اختيارك: وحدة تحكم صغيرة / وحدة تحكم تطبيق الهاتف / وحدة تحكم احترافية للكمبيوتر',
      brandingFeature: 'مجاناً: طباعة بلون واحد على الجزء العلوي من السوار',
      nfcFeature: 'مجاناً: شريحة NFC مبرمجة نحو الرابط الذي تختاره',
      optionFeature: 'خيار: منشط أو DJ + 1 فني إضاءة أو فني إضاءة فقط',
      controllerTitle: 'وحدة التحكم مضمنة — حسب اختيارك',
      controllerMini: 'وحدة تحكم صغيرة',
      controllerMiniDesc: 'مدمجة وسهلة الاستخدام. مثالية للفعاليات الصغيرة.',
      controllerMobile: 'وحدة تحكم تطبيق الهاتف',
      controllerMobileDesc: 'تحكم في أساورك من هاتفك الذكي عبر التطبيق المخصص.',
      controllerPro: 'وحدة تحكم احترافية',
      controllerProDesc: 'وحدة تحكم متقدمة للكمبيوتر. تحكم كامل للمحترفين.',
      pdfDownload: 'تحميل جدول الأسعار PDF',
      lowStock: 'مخزون محدود',
      reviews: 'آراء العملاء',
      noReviews: 'لا توجد آراء حتى الآن. كن أول من يعلق!',
      writeReview: 'اكتب رأيك',
      reviewName: 'اسمك',
      reviewEmail: 'بريدك الإلكتروني',
      reviewRating: 'التقييم',
      reviewComment: 'تعليقك',
      reviewSubmit: 'إرسال الرأي',
      reviewThanks: 'شكراً لرأيك!',
      avgRating: 'متوسط التقييم',
    },
    order: {
      verifying: 'جاري التحقق من الدفع...', pleaseWait: 'يرجى الانتظار',
      confirmed: 'تم تأكيد الدفع!', thanks: 'شكراً لشرائك',
      registered: 'تم تسجيل الطلب', expired: 'انتهت جلسة الدفع',
      orderRegistered: 'تم تسجيل طلبك',
    },
  },

  it: {
    lang: 'it',
    dir: 'ltr',
    nav: {
      home: 'Home',
      kits: 'I nostri Kit pronti all\'uso',
      contact: 'Contatti',
      blog: 'Blog',
      cta: 'Preventivo gratuito',
      cart: 'Carrello',
      gallery: 'Galleria',
    },
    gallery: {
      loadMore: 'Vedi altro',
      produit: 'Braccialetti e materiale',
      concert: 'Concerto', sport: 'Palestra',
      viewPhotos: 'Vedi le foto',
      title: 'Galleria',
      subtitle: 'Foto e video di serate illuminate da Party LED',
      photos: 'Foto',
      videos: 'Video',
      all: 'Tutti gli eventi',
      mariage: 'Matrimonio',
      festival: 'Festival',
      corporate: 'Aziendale',
      club: 'Club',
      autre: 'Altro',
      empty: 'Nessun contenuto in questa categoria per ora.',
      watch: 'Guarda',
      close: 'Chiudi',
      seo: 'Galleria foto e video — bracciali LED per matrimoni, festival, eventi aziendali e club.',
    },
    share: {
      label: 'Condividi',
      copy: 'Copia link',
      copied: 'Link copiato!',
    },
    seo: {
      homeTitle: 'Party LED — Bracciali LED Sincronizzati per Eventi | Francia e Dubai',
      homeDesc: 'Bracciali LED sincronizzati per matrimoni, festival, feste aziendali e club. Stampa in un colore e link NFC gratuiti. Kit da 50 a 1000 persone. Consegna Francia e Dubai.',
    },
    discount: {
      badge: 'Offerta di benvenuto',
      title: '10% di sconto',
      subtitle: 'sul tuo primo ordine',
      desc: 'Iscriviti e sarai il primo a conoscere le novità.',
      placeholder: 'Il tuo indirizzo email',
      cta: 'Ottieni il codice',
      thanks: 'Grazie! Il tuo codice sconto 10%:',
    },
    whatsapp: {
      open: 'Richiedi un preventivo su WhatsApp',
      title: 'Preventivo in 1 clic',
      subtitle: 'Scegli l\'ufficio più vicino a te',
      europe: 'Europa — Francia',
      europeDesc: 'Nouvelle Vision, Marsiglia',
      uae: 'Medio Oriente — UAE',
      uaeDesc: 'World Promotional Products, Dubai',
      recommended: 'Consigliato',
      message: 'Salve, vorrei un preventivo per un kit Party LED. Ecco il mio evento:',
    },
    hero: {
      badge: 'Animazione immersiva per eventi',
      title1: 'Trasforma il tuo evento in un\'',
      titleHighlight: 'esperienza indimenticabile',
      cta: 'Scopri i nostri kit pronti all\'uso',
    },
    kits: {
      title: 'I nostri Kit pronti all\'uso',
      viewAll: 'Vedi il catalogo completo',
      persons: 'Persone',
      addToCart: 'Aggiungi al carrello',
    },
    howItWorks: {
      badge: 'Semplice ed efficace',
      title: 'Come funziona',
      step1Title: 'Equipaggia i tuoi ospiti',
      step1Desc: 'Distribuisci i braccialetti LED a ogni partecipante. Un gesto semplice per una trasformazione spettacolare del tuo evento.',
      step2Title: 'Togli la linguetta',
      step2Desc: 'Basta togliere la linguetta di protezione della batteria: il bracciale si accende e si sincronizza da solo con tutti gli altri. Nessun accoppiamento, nessuna impostazione.',
      step3Title: 'Attiva l\'esperienza NFC',
      step3Desc: 'Il chip NFC integrato sblocca una dimensione digitale: contenuti esclusivi, interazioni personalizzate e ricordi connessi.',
    },
    features: {
      badge: 'Due tecnologie, un\'esperienza',
      title: 'Tecnologia all\'avanguardia',
      ledTitle: 'LED Sincronizzati',
      ledDesc: 'Crea uno spettacolo visivo collettivo che trasforma ogni momento forte in un ricordo indimenticabile.',
      ledItems: [
        'Effetti luminosi sincronizzati su tutto il pubblico',
        'Onde di colore pilotate in tempo reale',
        'Atmosfera immersiva nei momenti chiave',
        'Impatto visivo spettacolare su larga scala',
      ],
      nfcTitle: 'NFC Interattivo',
      nfcDesc: 'Aggiungi una dimensione digitale e interattiva che coinvolge i tuoi ospiti ben oltre la luce.',
      nfcItems: [
        'Accesso a contenuti digitali esclusivi',
        'Interazioni personalizzate durante l\'evento',
        'Attivazioni di marca e sorprese connesse',
        'Coinvolgimento rafforzato e ricordi condivisibili',
      ],
    },
    useCases: {
      badge: 'Per ogni occasione',
      title: 'Pensato per i tuoi eventi / attività',
      items: [
        { title: 'Matrimoni', desc: 'Crea un momento luminoso sincronizzato unico per il vostro primo ballo o la vostra entrata.' },
        { title: 'Feste private', desc: 'Trasforma la tua serata in uno spettacolo immersivo dove ogni invitato diventa protagonista.' },
        { title: 'Compleanni', desc: 'Offri un effetto wow indimenticabile per i momenti forti della celebrazione.' },
        { title: 'Festival', desc: 'Sincronizza centinaia di braccialetti per un\'esperienza collettiva su larga scala.' },
        { title: 'Studenti', desc: 'Distingui le tue serate studentesche con un\'animazione LED innovativa e memorabile.' },
        { title: 'Aziende', desc: 'Rafforza la coesione e l\'impatto dei tuoi seminari, gala e team building.' },
        { title: 'Lanci', desc: 'Colpisci gli animi durante i tuoi lanci di prodotto con uno show luminoso.' },
        { title: 'Attivazioni di marca', desc: 'Crea esperienze interattive che rafforzano il coinvolgimento e la visibilità.' },
        { title: 'Concerti', desc: 'Porta lo show fino all\'ultima fila: la sala cambia colore a ogni refrain.' },
        { title: 'Palestre e stadi', desc: 'Accendi le tribune nei colori del club, all\'ingresso delle squadre e a ogni gol.' },
      ],
    },
    immersion: {
      title: 'L\'emozione allo stato puro',
      desc: 'Centinaia di braccialetti che pulsano allo stesso ritmo. Uno spettacolo collettivo che crea un momento di unità ed emozione condivisa.',
    },
    benefits: {
      badge: 'Perché sceglierci',
      title: 'Molto più di un semplice accessorio',
      desc: 'Party LED è una soluzione per eventi completa che trasforma ogni incontro in un\'esperienza immersiva, interattiva e memorabile.',
      items: [
        { title: 'Impatto visivo spettacolare', desc: 'Uno show luminoso collettivo che colpisce le menti e crea un effetto wow istantaneo.' },
        { title: 'Implementazione semplice e rapida', desc: 'Nessuna competenza tecnica richiesta. Distribuisci, connetti, lancia.' },
        { title: 'Esperienza premium e innovativa', desc: 'Posiziona il tuo evento come un riferimento di innovazione e modernità.' },
        { title: 'Soluzione affidabile e adattabile', desc: 'Da 50 a 1000+ persone, la nostra tecnologia si adatta a tutte le scale.' },
      ],
    },
    trust: {
      badge: 'Si fidano di noi',
      title: 'Progettato per i professionisti',
      stats: [
        { value: '500+', label: 'Eventi animati' },
        { value: '50K+', label: 'Braccialetti distribuiti' },
        { value: '99%', label: 'Tasso di soddisfazione' },
        { value: '24/7', label: 'Supporto disponibile' },
      ],
      reassurance: [
        { title: 'Installazione semplice', desc: 'Pronto all\'uso in pochi minuti, senza competenze tecniche.' },
        { title: 'Accompagnamento dedicato', desc: 'Il nostro team vi guida dalla progettazione alla realizzazione del vostro evento.' },
        { title: 'Preventivo su misura', desc: 'Una soluzione adattata al vostro budget e al numero di partecipanti.' },
      ],
    },
    faq: {
      badge: 'Domande frequenti',
      title: 'FAQ',
      items: [
        { q: 'Come funzionano i braccialetti LED?', a: 'Ogni bracciale contiene un chip radio. Basta togliere la linguetta di protezione della batteria: il bracciale si accende e si sincronizza da solo con tutti gli altri, senza accoppiamento. Il controller incluso nel kit permette poi di cambiare colori ed effetti in tempo reale per tutta la sala.' },
        { q: 'Come sincronizza la console i braccialetti?', a: 'La console emette un segnale radio che raggiunge simultaneamente tutti i braccialetti in un raggio di diverse centinaia di metri. È possibile programmare sequenze, cambiare colori, creare onde luminose e attivare effetti speciali con un clic.' },
        { q: 'A cosa serve il chip NFC?', a: 'Il chip NFC permette di aggiungere una dimensione interattiva a ogni braccialetto. Avvicinando uno smartphone, i vostri ospiti possono accedere a contenuti esclusivi, partecipare ad attivazioni di marca, scoprire sorprese o condividere la loro esperienza sui social.' },
        { q: 'Per quali tipi di eventi è adatta questa soluzione?', a: 'La nostra soluzione si adatta a tutti i formati: matrimoni, compleanni, feste private, festival, eventi aziendali, seminari, gala, serate studentesche, lanci di prodotto e attivazioni di marca. Da 50 a oltre 1000 persone.' },
        { q: 'L\'installazione è complicata?', a: 'Per niente. I nostri kit sono progettati per essere pronti all\'uso. Basta distribuire i braccialetti agli ospiti e collegare la console. Il tutto è operativo in pochi minuti, senza alcuna competenza tecnica.' },
        { q: 'Si può personalizzare l\'esperienza?', a: 'Assolutamente. È possibile personalizzare colori, sequenze, effetti e ritmo. La console offre un controllo totale per adattare l\'animazione allo stile del vostro evento e ai vostri momenti chiave.' },
        { q: 'Come ordinare o richiedere un preventivo?', a: 'Potete ordinare direttamente dal nostro catalogo o contattarci tramite la pagina Contatti. Il nostro team vi risponderà entro 24 ore con una proposta adattata alle vostre esigenze.' },
      ],
    },
    finalCta: {
      title1: 'Pronti a creare un momento',
      titleHighlight: 'indimenticabile',
      titleEnd: '?',
      desc: 'Offrite ai vostri ospiti molto più di un evento. Aggiungete luce, emozione e interazione alla vostra prossima occasione.',
      cta: 'Scopri l\'esperienza',
    },
    footer: {
      desc: 'Soluzione di animazione immersiva per eventi. Braccialetti LED sincronizzati e connessi tramite tecnologia NFC.',
      nav: 'Navigazione',
      info: 'Informazioni',
      newsletter: 'Newsletter',
      newsletterDesc: 'Ricevi le nostre novità e offerte esclusive.',
      emailPlaceholder: 'La tua email',
      legal: 'Note legali',
      privacy: 'Politica sulla privacy',
      terms: 'Condizioni generali',
      refund: 'Politica di rimborso',
      rights: 'Tutti i diritti riservati.',
    },
    catalogue: {
      title: 'I nostri Kit pronti all\'uso',
      subtitle: 'Kit Party LED da 50 a 1.000 persone. Braccialetti LED sincronizzati, controller a scelta, stampa 1 colore e link NFC inclusi.',
      filterAll: 'Tutti',
      sortLabel: 'Ordina per',
      sortDefault: 'Ordine predefinito',
      sortPriceLow: 'Prezzo crescente',
      sortPriceHigh: 'Prezzo decrescente',
      sortName: 'Nome',
    },
    contact: {
      title: 'Richiesta di Preventivo',
      subtitle: 'Descrivi il tuo evento e ricevi un preventivo personalizzato per il tuo kit LED',
      info: 'Informazioni di contatto',
      europe: 'Nouvelle Vision (Europa)',
      uae: 'World Promotional Products (EAU)',
      email: 'Email',
      phone: 'Telefono',
      formTitle: 'Descrivi il tuo evento',
      name: 'Nome completo',
      emailField: 'Email',
      phoneField: 'Telefono',
      company: 'Azienda / Organizzazione',
      eventType: 'Tipo di evento',
      guestCount: 'Numero di ospiti',
      eventDate: 'Data dell\'evento',
      message: 'Dettagli del tuo evento',
      submit: 'Richiedi un preventivo gratuito',
      sending: 'Invio in corso...',
      successTitle: 'Richiesta inviata!',
      successMsg: 'Grazie per la tua richiesta di preventivo. Il nostro team ti risponderà entro 24 ore.',
      newQuote: 'Nuova richiesta',
      whyTitle: 'Perché sceglierci?',
      why1: 'Kit LED per eventi da 50 a 1000+ persone',
      why2: 'Consegna rapida in Francia e negli Emirati',
      why3: 'Preventivo personalizzato entro 24h',
      why4: 'Supporto tecnico prima e durante l\'evento',
      wedding: 'Matrimonio', festival: 'Festival', concert: 'Concerto',
      privateParty: 'Festa privata', corporate: 'Evento aziendale', other: 'Altro',
      choose: 'Scegli...',
      messagePlaceholder: 'Descrivi il tuo evento, le tue esigenze specifiche, il colore desiderato...',
    },
    blog: {
      title: 'Blog Party LED',
      subtitle: 'Consigli, guide e ispirazioni per illuminare i tuoi eventi',
      all: 'Tutti',
      readMore: 'Leggi l\'articolo',
      noArticles: 'Nessun articolo al momento',
      loading: 'Caricamento articoli...',
      backToBlog: 'Torna al blog',
      notFound: 'Articolo non trovato',
      share: 'Condividi questo articolo',
      cta: 'Richiedi un preventivo gratuito',
      related: 'Articoli correlati',
      newsletter: 'Resta informato',
      newsletterDesc: 'Ricevi i nostri consigli, offerte esclusive e novità LED direttamente nella tua casella di posta.',
      subscribe: 'Iscriviti',
      subscribed: 'Iscritto!',
    },
    cart: {
      title: 'Il tuo Carrello',
      empty: 'Il tuo carrello è vuoto',
      emptyDesc: 'Scopri i nostri kit LED e aggiungili al carrello',
      browseCatalogue: 'Sfoglia il catalogo',
      remove: 'Rimuovi',
      clearAll: 'Svuota il carrello',
      summary: 'Riepilogo',
      subtotal: 'Subtotale',
      shipping: 'Spedizione',
      free: 'Gratuita',
      total: 'Totale',
      checkout: 'Procedi all\'ordine',
    },
    checkout: {
      title: 'Completa l\'ordine',
      deliveryInfo: 'Informazioni di consegna',
      name: 'Nome completo', email: 'Email', phone: 'Telefono',
      address: 'Indirizzo di consegna',
      paymentMethod: 'Metodo di pagamento',
      stripe: 'Carta di credito (Stripe)', stripeDesc: 'Pagamento sicuro con carta',
      paypal: 'PayPal', paypalDesc: 'Pagamento tramite conto PayPal',
      pay: 'Paga', redirecting: 'Reindirizzamento...',
      summary: 'Riepilogo', quantity: 'Quantità',
      subtotal: 'Subtotale', shipping: 'Spedizione', free: 'Gratuita', total: 'Totale',
      secure: 'Pagamento sicuro al 100% con Stripe o PayPal',
      emptyCart: 'Carrello vuoto', emptyCartDesc: 'Aggiungi prodotti per effettuare un ordine',
      viewCatalogue: 'Vedi il catalogo',
    },
    product: {
      addToCart: 'Aggiungi al carrello', added: 'Aggiunto al carrello!',
      features: 'Caratteristiche', persons: 'Persone', loading: 'Caricamento...',
      back: 'Indietro',
      inStock: 'Disponibile',
      unitsAvailable: 'unità disponibili',
      minOrder: 'Ordine minimo',
      units: 'unità',
      unit: 'unità',
      quantity: 'Quantità',
      total: 'Totale',
      braceletFeature: '{n} braccialetti LED ultra-premium',
      controllerFeature: '1 controller a scelta: mini controller / controller per app mobile / controller professionale per computer',
      brandingFeature: 'Omaggio: personalizzazione a 1 colore sulla parte superiore del braccialetto',
      nfcFeature: 'Omaggio: chip NFC programmato verso il link di tua scelta',
      optionFeature: 'Opzione: Animatore o DJ + 1 tecnico luci o tecnico luci da solo',
      controllerTitle: 'Controller incluso — a tua scelta',
      controllerMini: 'Mini Controller',
      controllerMiniDesc: 'Compatto e facile da usare. Ideale per piccoli eventi.',
      controllerMobile: 'Controller App Mobile',
      controllerMobileDesc: 'Controlla i braccialetti dal tuo smartphone tramite l\'app dedicata.',
      controllerPro: 'Controller Professionale',
      controllerProDesc: 'Console avanzata per computer. Controllo totale per i professionisti.',
      pdfDownload: 'Scarica la griglia tariffaria PDF',
      lowStock: 'Stock limitato',
      reviews: 'Recensioni clienti',
      noReviews: 'Nessuna recensione al momento. Sii il primo!',
      writeReview: 'Lascia una recensione',
      reviewName: 'Il tuo nome',
      reviewEmail: 'La tua email',
      reviewRating: 'Voto',
      reviewComment: 'Il tuo commento',
      reviewSubmit: 'Invia recensione',
      reviewThanks: 'Grazie per la tua recensione!',
      avgRating: 'valutazione media',
    },
    order: {
      verifying: 'Verifica del pagamento...', pleaseWait: 'Attendere prego',
      confirmed: 'Pagamento confermato!', thanks: 'Grazie per il tuo acquisto',
      registered: 'Ordine registrato', expired: 'La sessione di pagamento è scaduta',
      orderRegistered: 'Il tuo ordine è stato registrato',
    },
  },
};

export default translations;
